import React from 'react'

const SideChartsIcon = (
  <>
    <path
      d="M6.08333 4.83398H4.41667C4.18655 4.83398 4 5.02053 4 5.25065V16.9173C4 17.1474 4.18655 17.334 4.41667 17.334H6.08333C6.31345 17.334 6.5 17.1474 6.5 16.9173V5.25065C6.5 5.02053 6.31345 4.83398 6.08333 4.83398Z"
      fill="#72C472"
    />
    <path
      d="M9.83333 9H8.16667C7.93655 9 7.75 9.18655 7.75 9.41667V16.9167C7.75 17.1468 7.93655 17.3333 8.16667 17.3333H9.83333C10.0635 17.3333 10.25 17.1468 10.25 16.9167V9.41667C10.25 9.18655 10.0635 9 9.83333 9Z"
      fill="#ED7064"
    />
    <path
      d="M13.5833 4.83398H11.9167C11.6865 4.83398 11.5 5.02053 11.5 5.25065V16.9173C11.5 17.1474 11.6865 17.334 11.9167 17.334H13.5833C13.8135 17.334 14 17.1474 14 16.9173V5.25065C14 5.02053 13.8135 4.83398 13.5833 4.83398Z"
      fill="#72C472"
    />
    <path
      d="M17.3333 9H15.6667C15.4365 9 15.25 9.18655 15.25 9.41667V16.9167C15.25 17.1468 15.4365 17.3333 15.6667 17.3333H17.3333C17.5635 17.3333 17.75 17.1468 17.75 16.9167V9.41667C17.75 9.18655 17.5635 9 17.3333 9Z"
      fill="#ED7064"
    />
    <path
      d="M2.33333 0.666992H0.666667C0.436548 0.666992 0.25 0.85354 0.25 1.08366V16.917C0.25 17.1471 0.436548 17.3337 0.666667 17.3337H2.33333C2.56345 17.3337 2.75 17.1471 2.75 16.917V1.08366C2.75 0.85354 2.56345 0.666992 2.33333 0.666992Z"
      fill="#72C472"
    />
  </>
)

export default SideChartsIcon
